var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#FAD1C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8249 18.128C17.0809 18.128 17.2995 18.2187 17.4809 18.4C17.6622 18.5813 17.7529 18.8053 17.7529 19.072C17.7529 19.328 17.6622 19.5467 17.4809 19.728C17.2995 19.9093 17.0809 20 16.8249 20H11.3689C11.0595 20 10.7929 19.8933 10.5689 19.68C10.3555 19.456 10.2489 19.1893 10.2489 18.88C10.2489 18.6667 10.3022 18.4693 10.4089 18.288C10.5262 18.1067 10.6809 17.968 10.8729 17.872C12.2595 16.7733 13.2889 15.8187 13.9609 15.008C14.6435 14.1867 15.0702 13.5147 15.2409 12.992C15.4115 12.4587 15.4969 11.92 15.4969 11.376C15.4969 10.896 15.3529 10.512 15.0649 10.224C14.7875 9.92533 14.4142 9.776 13.9449 9.776C13.5395 9.776 13.2035 9.88267 12.9369 10.096C12.6809 10.3093 12.5209 10.6027 12.4569 10.976C12.3715 11.136 12.2542 11.264 12.1049 11.36C11.9662 11.4453 11.8115 11.488 11.6409 11.488C11.3529 11.488 11.1129 11.392 10.9209 11.2C10.7289 11.008 10.6329 10.784 10.6329 10.528C10.6329 10.3893 10.6649 10.256 10.7289 10.128C10.9315 9.43467 11.3102 8.89067 11.8649 8.496C12.4302 8.09067 13.1129 7.888 13.9129 7.888C14.5955 7.888 15.1982 8.032 15.7209 8.32C16.2542 8.608 16.6649 9.01333 16.9529 9.536C17.2515 10.048 17.4009 10.64 17.4009 11.312C17.4009 11.888 17.2942 12.48 17.0809 13.088C16.8675 13.6853 16.4622 14.3947 15.8649 15.216C15.2782 16.0373 14.4355 17.008 13.3369 18.128H16.8249Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.a1d3f37fccf9a23b306f0de68c578c50.svg";
export { ForwardRef as ReactComponent };